import { Normas_urbanisticas } from './../../../models/normas_urbanisticas.model';
import { Component } from "@angular/core";
import { FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';


@Component({
  selector: "page-normas_urbanisticas",
  templateUrl: "./normas_urbanisticas.component.html",
  styleUrls: ["./normas_urbanisticas.component.css"],
  providers: [FormService]
})

export class Normas_urbanisticasComponent {
  public rows = [];
  public actualRow;
  public normas_urbanisticas: Normas_urbanisticas;
  public form;
  public formulario;

  public form131 = false;
  public form132 = false;
  public form133 = false;

  public form111 = false;
  public form112 = false;
  public form113 = false;
  public form114 = false;
  public form115 = false;

  public form211 = false;
  public form212 = false;
  public form213 = false;
  public form214 = false;

  public form231 = false;
  public form232 = false;
  public form233 = false;
  public form234 = false;
  public form235 = false;

  public form251;
  public form252;
  public form253;
  public form254;
  public form255;
  public num;
  public num2;
  public matcher = new FormService();

  constructor() {

    this.formulario = localStorage.getItem("form")
    console.log(this.formulario);



    if (this.formulario == "1-1.1") {
      this.form111 = true
      this.num = '6.2'
    }
    if (this.formulario == "1-1.2") {
      this.form112 = true
      this.num = '6.2'
    }
    if (this.formulario == "1-1.3") {
      this.form113 = true
      this.num = '6.2'
      this.num2 = '6.3'
    }
    if (this.formulario == "1-1.4") {
      this.form114 = true
      this.num = '6.2'
    }
    if (this.formulario == "1-1.5") {
      this.form115 = true
      this.num = '6.2'
    }

    if (this.formulario == "1-3.1") {
      this.form131 = true
    }
    if (this.formulario == "1-3.2") {
      this.form132 = true
    }
    if (this.formulario == "1-3.3") {
      this.form133 = true
    }


    if (this.formulario == "2-1.1") {
      this.form211 = true
    }
    if (this.formulario == "2-1.2") {
      this.form212 = true
    }
    if (this.formulario == "2-1.3") {
      this.form213 = true
    }
    if (this.formulario == "2-1.4") {
      this.form214 = true
    }

    if (this.formulario == "2-3.1") {
      this.form231 = true;
    }
    if (this.formulario == "2-3.2") {
      this.form232 = true;
    }
    if (this.formulario == "2-3.3") {
      this.form233 = true;
    }
    if (this.formulario == "2-3.4") {
      this.form234 = true;
    }
    if (this.formulario == "2-3.5") {
      this.form235 = true;
    }

    if (this.formulario == "2-5.1") {
      this.form251 = true;
    }
    if (this.formulario == "2-5.2") {
      this.form252 = true;
    }
    if (this.formulario == "2-5.3") {
      this.form253 = true;
    }
    if (this.formulario == "2-5.4") {
      this.form254 = true;
    }
    if (this.formulario == "2-5.5") {
      this.form255 = true;
    }


    this.form = new FormGroup({
      predioEmplazadoArea: new FormControl(''),
      acogeNuevasNormas: new FormControl(''),
      usoSuelo: new FormControl(''),
      predioEmplazadoProteccion: new FormControl(''),
      predioDeclaratoria: new FormControl(''),
      viviendaParte: new FormControl(''),
      viviendaAmplia: new FormControl(''),

      /* densidad */
      densid_Proyectada_Permiso: new FormControl(''),
      densid_Permitido_Norma: new FormControl(''),
      densid_Ampliacion_Alteracion: new FormControl(''),
      densid_Total_Proyecto: new FormControl(''),
      /* COEFICIENTE DE OCUPACIÓN PISOS SUPERIORES (sobre 1er piso) */
      coefPisos_Proyectada_Permiso: new FormControl(''),
      coefPisos_Permitido_Norma: new FormControl(''),
      coefPisos_Ampliacion_Alteracion: new FormControl(''),
      coefPisos_Total_Proyecto: new FormControl(''),
      /* COEFICIENTE DE OCUPACIÓN DE SUELO (1er piso) */
      coefSuelo_Proyectada_Permiso: new FormControl(''),
      coefSuelo_Permitido_Norma: new FormControl(''),
      coefSuelo_Ampliacion_Alteracion: new FormControl(''),
      coefSuelo_Total_Proyecto: new FormControl(''),
      /* COEFICIENTE DE CONSTRUCTIBILIDAD */
      coefConstr_Proyectada_Permiso: new FormControl(''),
      coefConstr_Permitido_Norma: new FormControl(''),
      coefConstr_Ampliacion_Alteracion: new FormControl(''),
      coefConstr_Total_Proyecto: new FormControl(''),
      /* DISTANCIAMIENTOS */
      distanciamientos_Proyectada_Permiso: new FormControl(''),
      distanciamientos_Permitido_Norma: new FormControl(''),
      distanciamientos_Ampliacion_Alteracion: new FormControl(''),
      distanciamientos_Total_Proyecto: new FormControl(''),
      /* RASANTE */
      rasante_Proyectada_Permiso: new FormControl(''),
      rasante_Permitido_Norma: new FormControl(''),
      rasante_Ampliacion_Alteracion: new FormControl(''),
      rasante_Total_Proyecto: new FormControl(''),
      /* SISTEMA DE AGRUPAMIENTO */
      agrupamiento_Proyectada_Permiso: new FormControl(''),
      agrupamiento_Permitido_Norma: new FormControl(''),
      agrupamiento_Ampliacion_Alteracion: new FormControl(''),
      agrupamiento_Total_Proyecto: new FormControl(''),
      /* ADOSAMIENTO */
      adosamiento_Proyectada_Permiso: new FormControl(''),
      adosamiento_Permitido_Norma: new FormControl(''),
      adosamiento_Ampliacion_Alteracion: new FormControl(''),
      adosamiento_Total_Proyecto: new FormControl(''),
      /* ANTEJARDÍN */
      antejardin_Proyectada_Permiso: new FormControl(''),
      antejardin_Permitido_Norma: new FormControl(''),
      antejardin_Ampliacion_Alteracion: new FormControl(''),
      antejardin_Total_Proyecto: new FormControl(''),
      /* ALTURA EN METROS Y/O PISOS */
      altura_Proyectada_Permiso: new FormControl(''),
      altura_Permitido_Norma: new FormControl(''),
      altura_Ampliacion_Alteracion: new FormControl(''),
      altura_Total_Proyecto: new FormControl(''),
      /* ESTACIONAMIENTOS AUTOMÓVILES */
      automoviles_Proyectada_Permiso: new FormControl(''),
      automoviles_Permitido_Norma: new FormControl(''),
      automoviles_Ampliacion_Alteracion: new FormControl(''),
      automoviles_Total_Proyecto: new FormControl(''),
      /* ESTACIONAMIENTOS BICICLETAS */
      bicicletas_Proyectada_Permiso: new FormControl(''),
      bicicletas_Permitido_Norma: new FormControl(''),
      bicicletas_Ampliacion_Alteracion: new FormControl(''),
      bicicletas_Total_Proyecto: new FormControl(''),
      /* ESTACIONAMIENTOS OTROS VEHÍCULOS (ESPECIFICAR */
      otrosVehiculos_Especificar: new FormControl(''), //especificar
      otrosVehiculos_Proyectada_Permiso: new FormControl(''),
      otrosVehiculos_Permitido_Norma: new FormControl(''),
      otrosVehiculos_Ampliacion_Alteracion: new FormControl(''),
      otrosVehiculos_Total_Proyecto: new FormControl(''),
      /* ESTACIONAMIENTOS PARA PERSONAS CON DISCAPACIDAD */
      personasDiscapacidad_Proyectada_Permiso: new FormControl(''),
      personasDiscapacidad_Permitido_Norma: new FormControl(''),
      personasDiscapacidad_Ampliacion_Alteracion: new FormControl(''),
      personasDiscapacidad_Total_Proyecto: new FormControl(''),
      /* DESCUENTO ESTACIONAMIENTO PARA AUTOMÓVILES POR
      ESTACIONAMIENTO PARA BICICLETAS  o  (PERMISO(S) ANTERIOR(ES))*/
      descuento_Est: new FormControl(''),
      descuento_EstCant: new FormControl(''),
      /* DESCUENTO ESTACIONAMIENTO PARA AUTOMOVILES POR
      ESTACIONAMIENTO PARA BICICLETAS INCLUIDO PROYECTO */
      descuento_EstIncluido: new FormControl(''),
      descuento_EstIncluidoCant: new FormControl(''),


      //Form 133
      distanciamientos_V1_Otorgado: new FormControl(''),
      distanciamientos_V1_Modificado: new FormControl(''),
      adosamiento_V1_Otorgado: new FormControl(''),
      adosamiento_V1_Modificado: new FormControl(''),
      antejardin_V1_Otorgado: new FormControl(''),
      antejardin_V1_Modificado: new FormControl(''),
      altura_V1_Otorgado: new FormControl(''),
      altura_V1_Modificado: new FormControl(''),
      esta_Auto_V1_Otorgado: new FormControl(''),
      esta_Auto_V1_Modificado: new FormControl(''),
      esta_Bici_V1_Otorgado: new FormControl(''),
      esta_Bici_V1_Modificado: new FormControl(''),

      distanciamientos_V2_Otorgado: new FormControl(''),
      distanciamientos_V2_Modificado: new FormControl(''),
      adosamiento_V2_Otorgado: new FormControl(''),
      adosamiento_V2_Modificado: new FormControl(''),
      antejardin_V2_Otorgado: new FormControl(''),
      antejardin_V2_Modificado: new FormControl(''),
      altura_V2_Otorgado: new FormControl(''),
      altura_V2_Modificado: new FormControl(''),
      esta_Auto_V2_Otorgado: new FormControl(''),
      esta_Auto_V2_Modificado: new FormControl(''),
      esta_Bici_V2_Otorgado: new FormControl(''),
      esta_Bici_V2_Modificado: new FormControl(''),

      distanciamientos_V3_Otorgado: new FormControl(''),
      distanciamientos_V3_Modificado: new FormControl(''),
      adosamiento_V3_Otorgado: new FormControl(''),
      adosamiento_V3_Modificado: new FormControl(''),
      antejardin_V3_Otorgado: new FormControl(''),
      antejardin_V3_Modificado: new FormControl(''),
      altura_V3_Otorgado: new FormControl(''),
      altura_V3_Modificado: new FormControl(''),
      esta_Auto_V3_Otorgado: new FormControl(''),
      esta_Auto_V3_Modificado: new FormControl(''),
      esta_Bici_V3_Otorgado: new FormControl(''),
      esta_Bici_V3_Modificado: new FormControl(''),
      esta_Bici_Permitido_Otorgado: new FormControl(''),
      esta_Bici_Permitido_Modificado: new FormControl(''),



    })

    if (!JSON.parse(localStorage.getItem("normas_urbanisticas"))) {
      localStorage.setItem("normas_urbanisticas", JSON.stringify(this.rows));
    } else {
      this.rows = JSON.parse(localStorage.getItem("normas_urbanisticas"));
      this.form.controls['predioEmplazadoArea'].setValue(this.rows[0] ? this.rows[0].predioEmplazadoArea : '')
      this.form.controls['acogeNuevasNormas'].setValue(this.rows[0] ? this.rows[0].acogeNuevasNormas : '')
      this.form.controls['usoSuelo'].setValue(this.rows[0] ? this.rows[0].usoSuelo : '')
      this.form.controls['predioEmplazadoProteccion'].setValue(this.rows[0] ? this.rows[0].predioEmplazadoProteccion : '')
      this.form.controls['predioDeclaratoria'].setValue(this.rows[0] ? this.rows[0].predioDeclaratoria : '')
      this.form.controls['viviendaParte'].setValue(this.rows[0] ? this.rows[0].viviendaParte : '')
      this.form.controls['viviendaAmplia'].setValue(this.rows[0] ? this.rows[0].viviendaAmplia : '')
      /* densidad */
      this.form.controls['densid_Proyectada_Permiso'].setValue(this.rows[0] ? this.rows[0].densid_Proyectada_Permiso : '')
      this.form.controls['densid_Permitido_Norma'].setValue(this.rows[0] ? this.rows[0].densid_Permitido_Norma : '')
      this.form.controls['densid_Ampliacion_Alteracion'].setValue(this.rows[0] ? this.rows[0].densid_Ampliacion_Alteracion : '')
      this.form.controls['densid_Total_Proyecto'].setValue(this.rows[0] ? this.rows[0].densid_Total_Proyecto : '')
      /* COEFICIENTE DE OCUPACIÓN PISOS SUPERIORES (sobre 1er piso) */
      this.form.controls['coefPisos_Proyectada_Permiso'].setValue(this.rows[0] ? this.rows[0].coefPisos_Proyectada_Permiso : '')
      this.form.controls['coefPisos_Permitido_Norma'].setValue(this.rows[0] ? this.rows[0].coefPisos_Permitido_Norma : '')
      this.form.controls['coefPisos_Ampliacion_Alteracion'].setValue(this.rows[0] ? this.rows[0].coefPisos_Ampliacion_Alteracion : '')
      this.form.controls['coefPisos_Total_Proyecto'].setValue(this.rows[0] ? this.rows[0].coefPisos_Total_Proyecto : '')
      /* COEFICIENTE DE OCUPACIÓN DE SUELO (1er piso) */
      this.form.controls['coefSuelo_Proyectada_Permiso'].setValue(this.rows[0] ? this.rows[0].coefSuelo_Proyectada_Permiso : '')
      this.form.controls['coefSuelo_Permitido_Norma'].setValue(this.rows[0] ? this.rows[0].coefSuelo_Permitido_Norma : '')
      this.form.controls['coefSuelo_Ampliacion_Alteracion'].setValue(this.rows[0] ? this.rows[0].coefSuelo_Ampliacion_Alteracion : '')
      this.form.controls['coefSuelo_Total_Proyecto'].setValue(this.rows[0] ? this.rows[0].coefSuelo_Total_Proyecto : '')
      /* COEFICIENTE DE CONSTRUCTIBILIDAD */
      this.form.controls['coefConstr_Proyectada_Permiso'].setValue(this.rows[0] ? this.rows[0].coefConstr_Proyectada_Permiso : '')
      this.form.controls['coefConstr_Permitido_Norma'].setValue(this.rows[0] ? this.rows[0].coefConstr_Permitido_Norma : '')
      this.form.controls['coefConstr_Ampliacion_Alteracion'].setValue(this.rows[0] ? this.rows[0].coefConstr_Ampliacion_Alteracion : '')
      this.form.controls['coefConstr_Total_Proyecto'].setValue(this.rows[0] ? this.rows[0].coefConstr_Total_Proyecto : '')
      /* DISTANCIAMIENTOS */
      this.form.controls['distanciamientos_Proyectada_Permiso'].setValue(this.rows[0] ? this.rows[0].distanciamientos_Proyectada_Permiso : '')
      this.form.controls['distanciamientos_Permitido_Norma'].setValue(this.rows[0] ? this.rows[0].distanciamientos_Permitido_Norma : '')
      this.form.controls['distanciamientos_Ampliacion_Alteracion'].setValue(this.rows[0] ? this.rows[0].distanciamientos_Ampliacion_Alteracion : '')
      this.form.controls['distanciamientos_Total_Proyecto'].setValue(this.rows[0] ? this.rows[0].distanciamientos_Total_Proyecto : '')
      /* RASANTE */
      this.form.controls['rasante_Proyectada_Permiso'].setValue(this.rows[0] ? this.rows[0].rasante_Proyectada_Permiso : '')
      this.form.controls['rasante_Permitido_Norma'].setValue(this.rows[0] ? this.rows[0].rasante_Permitido_Norma : '')
      this.form.controls['rasante_Ampliacion_Alteracion'].setValue(this.rows[0] ? this.rows[0].rasante_Ampliacion_Alteracion : '')
      this.form.controls['rasante_Total_Proyecto'].setValue(this.rows[0] ? this.rows[0].rasante_Total_Proyecto : '')
      /* SISTEMA DE AGRUPAMIENTO */
      this.form.controls['agrupamiento_Proyectada_Permiso'].setValue(this.rows[0] ? this.rows[0].agrupamiento_Proyectada_Permiso : '')
      this.form.controls['agrupamiento_Permitido_Norma'].setValue(this.rows[0] ? this.rows[0].agrupamiento_Permitido_Norma : '')
      this.form.controls['agrupamiento_Ampliacion_Alteracion'].setValue(this.rows[0] ? this.rows[0].agrupamiento_Ampliacion_Alteracion : '')
      this.form.controls['agrupamiento_Total_Proyecto'].setValue(this.rows[0] ? this.rows[0].agrupamiento_Total_Proyecto : '')
      /* ADOSAMIENTO */
      this.form.controls['adosamiento_Proyectada_Permiso'].setValue(this.rows[0] ? this.rows[0].adosamiento_Proyectada_Permiso : '')
      this.form.controls['adosamiento_Permitido_Norma'].setValue(this.rows[0] ? this.rows[0].adosamiento_Permitido_Norma : '')
      this.form.controls['adosamiento_Ampliacion_Alteracion'].setValue(this.rows[0] ? this.rows[0].adosamiento_Ampliacion_Alteracion : '')
      this.form.controls['adosamiento_Total_Proyecto'].setValue(this.rows[0] ? this.rows[0].adosamiento_Total_Proyecto : '')
      /* ANTEJARDÍN */
      this.form.controls['antejardin_Proyectada_Permiso'].setValue(this.rows[0] ? this.rows[0].antejardin_Proyectada_Permiso : '')
      this.form.controls['antejardin_Permitido_Norma'].setValue(this.rows[0] ? this.rows[0].antejardin_Permitido_Norma : '')
      this.form.controls['antejardin_Ampliacion_Alteracion'].setValue(this.rows[0] ? this.rows[0].antejardin_Ampliacion_Alteracion : '')
      this.form.controls['antejardin_Total_Proyecto'].setValue(this.rows[0] ? this.rows[0].antejardin_Total_Proyecto : '')
      /* ALTURA EN METROS Y/O PISOS */
      this.form.controls['altura_Proyectada_Permiso'].setValue(this.rows[0] ? this.rows[0].altura_Proyectada_Permiso : '')
      this.form.controls['altura_Permitido_Norma'].setValue(this.rows[0] ? this.rows[0].altura_Permitido_Norma : '')
      this.form.controls['altura_Ampliacion_Alteracion'].setValue(this.rows[0] ? this.rows[0].altura_Ampliacion_Alteracion : '')
      this.form.controls['altura_Total_Proyecto'].setValue(this.rows[0] ? this.rows[0].altura_Total_Proyecto : '')
      /* ESTACIONAMIENTOS AUTOMÓVILES */
      this.form.controls['automoviles_Proyectada_Permiso'].setValue(this.rows[0] ? this.rows[0].automoviles_Proyectada_Permiso : '')
      this.form.controls['automoviles_Permitido_Norma'].setValue(this.rows[0] ? this.rows[0].automoviles_Permitido_Norma : '')
      this.form.controls['automoviles_Ampliacion_Alteracion'].setValue(this.rows[0] ? this.rows[0].automoviles_Ampliacion_Alteracion : '')
      this.form.controls['automoviles_Total_Proyecto'].setValue(this.rows[0] ? this.rows[0].automoviles_Total_Proyecto : '')
      /* ESTACIONAMIENTOS BICICLETAS */
      this.form.controls['bicicletas_Proyectada_Permiso'].setValue(this.rows[0] ? this.rows[0].bicicletas_Proyectada_Permiso : '')
      this.form.controls['bicicletas_Permitido_Norma'].setValue(this.rows[0] ? this.rows[0].bicicletas_Permitido_Norma : '')
      this.form.controls['bicicletas_Ampliacion_Alteracion'].setValue(this.rows[0] ? this.rows[0].bicicletas_Ampliacion_Alteracion : '')
      this.form.controls['bicicletas_Total_Proyecto'].setValue(this.rows[0] ? this.rows[0].bicicletas_Total_Proyecto : '')
      /* ESTACIONAMIENTOS OTROS VEHÍCULOS (ESPECIFICAR */
      this.form.controls['otrosVehiculos_Especificar'].setValue(this.rows[0] ? this.rows[0].otrosVehiculos_Especificar : '') //especificar
      this.form.controls['otrosVehiculos_Proyectada_Permiso'].setValue(this.rows[0] ? this.rows[0].otrosVehiculos_Proyectada_Permiso : '')
      this.form.controls['otrosVehiculos_Permitido_Norma'].setValue(this.rows[0] ? this.rows[0].otrosVehiculos_Permitido_Norma : '')
      this.form.controls['otrosVehiculos_Ampliacion_Alteracion'].setValue(this.rows[0] ? this.rows[0].otrosVehiculos_Ampliacion_Alteracion : '')
      this.form.controls['otrosVehiculos_Total_Proyecto'].setValue(this.rows[0] ? this.rows[0].otrosVehiculos_Total_Proyecto : '')
      /* ESTACIONAMIENTOS PARA PERSONAS CON DISCAPACIDAD */
      this.form.controls['personasDiscapacidad_Proyectada_Permiso'].setValue(this.rows[0] ? this.rows[0].personasDiscapacidad_Proyectada_Permiso : '')
      this.form.controls['personasDiscapacidad_Permitido_Norma'].setValue(this.rows[0] ? this.rows[0].personasDiscapacidad_Permitido_Norma : '')
      this.form.controls['personasDiscapacidad_Ampliacion_Alteracion'].setValue(this.rows[0] ? this.rows[0].personasDiscapacidad_Ampliacion_Alteracion : '')
      this.form.controls['personasDiscapacidad_Total_Proyecto'].setValue(this.rows[0] ? this.rows[0].personasDiscapacidad_Total_Proyecto : '')
      /* DESCUENTO ESTACIONAMIENTO PARA AUTOMÓVILES POR
      ESTACIONAMIENTO PARA BICICLETAS  o  (PERMISO(S) ANTERIOR(ES))*/
      this.form.controls['descuento_Est'].setValue(this.rows[0] ? this.rows[0].descuento_Est : '')
      this.form.controls['descuento_EstCant'].setValue(this.rows[0] ? this.rows[0].descuento_EstCant : '')
      /* DESCUENTO ESTACIONAMIENTO PARA AUTOMOVILES POR
      ESTACIONAMIENTO PARA BICICLETAS INCLUIDO PROYECTO */
      this.form.controls['descuento_EstIncluido'].setValue(this.rows[0] ? this.rows[0].descuento_EstIncluido : '')
      this.form.controls['descuento_EstIncluidoCant'].setValue(this.rows[0] ? this.rows[0].descuento_EstIncluidoCant : '')

      //Form 133
      this.form.controls['distanciamientos_V1_Otorgado'].setValue(this.rows[0] ? this.rows[0].distanciamientos_V1_Otorgado : '')
      this.form.controls['distanciamientos_V1_Modificado'].setValue(this.rows[0] ? this.rows[0].distanciamientos_V1_Modificado : '')
      this.form.controls['adosamiento_V1_Otorgado'].setValue(this.rows[0] ? this.rows[0].adosamiento_V1_Otorgado : '')
      this.form.controls['adosamiento_V1_Modificado'].setValue(this.rows[0] ? this.rows[0].adosamiento_V1_Modificado : '')
      this.form.controls['antejardin_V1_Otorgado'].setValue(this.rows[0] ? this.rows[0].antejardin_V1_Otorgado : '')
      this.form.controls['antejardin_V1_Modificado'].setValue(this.rows[0] ? this.rows[0].antejardin_V1_Modificado : '')
      this.form.controls['altura_V1_Otorgado'].setValue(this.rows[0] ? this.rows[0].altura_V1_Otorgado : '')
      this.form.controls['altura_V1_Modificado'].setValue(this.rows[0] ? this.rows[0].altura_V1_Modificado : '')
      this.form.controls['esta_Auto_V1_Otorgado'].setValue(this.rows[0] ? this.rows[0].esta_Auto_V1_Otorgado : '')
      this.form.controls['esta_Auto_V1_Modificado'].setValue(this.rows[0] ? this.rows[0].esta_Auto_V1_Modificado : '')
      this.form.controls['esta_Bici_V1_Otorgado'].setValue(this.rows[0] ? this.rows[0].esta_Bici_V1_Otorgado : '')
      this.form.controls['esta_Bici_V1_Modificado'].setValue(this.rows[0] ? this.rows[0].esta_Bici_V1_Modificado : '')

      this.form.controls['distanciamientos_V2_Otorgado'].setValue(this.rows[0] ? this.rows[0].distanciamientos_V2_Otorgado : '')
      this.form.controls['distanciamientos_V2_Modificado'].setValue(this.rows[0] ? this.rows[0].distanciamientos_V2_Modificado : '')
      this.form.controls['adosamiento_V2_Otorgado'].setValue(this.rows[0] ? this.rows[0].adosamiento_V2_Otorgado : '')
      this.form.controls['adosamiento_V2_Modificado'].setValue(this.rows[0] ? this.rows[0].adosamiento_V2_Modificado : '')
      this.form.controls['antejardin_V2_Otorgado'].setValue(this.rows[0] ? this.rows[0].antejardin_V2_Otorgado : '')
      this.form.controls['antejardin_V2_Modificado'].setValue(this.rows[0] ? this.rows[0].antejardin_V2_Modificado : '')
      this.form.controls['altura_V2_Otorgado'].setValue(this.rows[0] ? this.rows[0].altura_V2_Otorgado : '')
      this.form.controls['altura_V2_Modificado'].setValue(this.rows[0] ? this.rows[0].altura_V2_Modificado : '')
      this.form.controls['esta_Auto_V2_Otorgado'].setValue(this.rows[0] ? this.rows[0].esta_Auto_V2_Otorgado : '')
      this.form.controls['esta_Auto_V2_Modificado'].setValue(this.rows[0] ? this.rows[0].esta_Auto_V2_Modificado : '')
      this.form.controls['esta_Bici_V2_Otorgado'].setValue(this.rows[0] ? this.rows[0].esta_Bici_V2_Otorgado : '')
      this.form.controls['esta_Bici_V2_Modificado'].setValue(this.rows[0] ? this.rows[0].esta_Bici_V2_Modificado : '')

      this.form.controls['distanciamientos_V3_Otorgado'].setValue(this.rows[0] ? this.rows[0].distanciamientos_V3_Otorgado : '')
      this.form.controls['distanciamientos_V3_Modificado'].setValue(this.rows[0] ? this.rows[0].distanciamientos_V3_Modificado : '')
      this.form.controls['adosamiento_V3_Otorgado'].setValue(this.rows[0] ? this.rows[0].adosamiento_V3_Otorgado : '')
      this.form.controls['adosamiento_V3_Modificado'].setValue(this.rows[0] ? this.rows[0].adosamiento_V3_Modificado : '')
      this.form.controls['antejardin_V3_Otorgado'].setValue(this.rows[0] ? this.rows[0].antejardin_V3_Otorgado : '')
      this.form.controls['antejardin_V3_Modificado'].setValue(this.rows[0] ? this.rows[0].antejardin_V3_Modificado : '')
      this.form.controls['altura_V3_Otorgado'].setValue(this.rows[0] ? this.rows[0].altura_V3_Otorgado : '')
      this.form.controls['altura_V3_Modificado'].setValue(this.rows[0] ? this.rows[0].altura_V3_Modificado : '')
      this.form.controls['esta_Auto_V3_Otorgado'].setValue(this.rows[0] ? this.rows[0].esta_Auto_V3_Otorgado : '')
      this.form.controls['esta_Auto_V3_Modificado'].setValue(this.rows[0] ? this.rows[0].esta_Auto_V3_Modificado : '')
      this.form.controls['esta_Bici_V3_Otorgado'].setValue(this.rows[0] ? this.rows[0].esta_Bici_V3_Otorgado : '')
      this.form.controls['esta_Bici_V3_Modificado'].setValue(this.rows[0] ? this.rows[0].esta_Bici_V3_Modificado : '')
      this.form.controls['esta_Bici_Permitido_Otorgado'].setValue(this.rows[0] ? this.rows[0].esta_Bici_Permitido_Otorgado : '')
      this.form.controls['esta_Bici_Permitido_Modificado'].setValue(this.rows[0] ? this.rows[0].esta_Bici_Permitido_Modificado : '')

    }

    //this.normas_urbanisticas = {constr_perm:'',constr_proy:'', ocup_perm:'', ocup_proy:'', alt_perm:'', alt_proy:'', rasant_perm:'', rasant_proy:'', dist_perm:'',dist_proy:'',suelo_perm:'',suelo_proy:'', densid_perm:'', densid_proy:'', adosam_perm:'', adosam_proy:'', antej_perm:'', antej_proy:'', est_req:'', est_proy:'' };
  }

  add_normas_urbanisticas() {
    localStorage.setItem("normas_urbanisticas", JSON.stringify([]));
    this.actualRow = localStorage.getItem("normas_urbanisticas");
    this.rows = JSON.parse(this.actualRow);
    this.rows = this.rows.concat({
      predioEmplazadoArea: this.form.value.predioEmplazadoArea,
      acogeNuevasNormas: this.form.value.acogeNuevasNormas,
      usoSuelo: this.form.value.usoSuelo,
      predioEmplazadoProteccion: this.form.value.predioEmplazadoProteccion,
      predioDeclaratoria: this.form.value.predioDeclaratoria,
      viviendaParte: this.form.value.viviendaParte,
      viviendaAmplia: this.form.value.viviendaAmplia,
      /* densidad */
      densid_Proyectada_Permiso: this.form.value.densid_Proyectada_Permiso,
      densid_Permitido_Norma: this.form.value.densid_Permitido_Norma,
      densid_Ampliacion_Alteracion:
        this.form.value.densid_Ampliacion_Alteracion,
      densid_Total_Proyecto: this.form.value.densid_Total_Proyecto,
      /* COEFICIENTE DE OCUPACIÓN PISOS SUPERIORES (sobre 1er piso) */
      coefPisos_Proyectada_Permiso:
        this.form.value.coefPisos_Proyectada_Permiso,
      coefPisos_Permitido_Norma: this.form.value.coefPisos_Permitido_Norma,
      coefPisos_Ampliacion_Alteracion:
        this.form.value.coefPisos_Ampliacion_Alteracion,
      coefPisos_Total_Proyecto: this.form.value.coefPisos_Total_Proyecto,
      /* COEFICIENTE DE OCUPACIÓN DE SUELO (1er piso) */
      coefSuelo_Proyectada_Permiso:
        this.form.value.coefSuelo_Proyectada_Permiso,
      coefSuelo_Permitido_Norma: this.form.value.coefSuelo_Permitido_Norma,
      coefSuelo_Ampliacion_Alteracion:
        this.form.value.coefSuelo_Ampliacion_Alteracion,
      coefSuelo_Total_Proyecto: this.form.value.coefSuelo_Total_Proyecto,
      /* COEFICIENTE DE CONSTRUCTIBILIDAD */
      coefConstr_Proyectada_Permiso:
        this.form.value.coefConstr_Proyectada_Permiso,
      coefConstr_Permitido_Norma:
        this.form.value.coefConstr_Permitido_Norma,
      coefConstr_Ampliacion_Alteracion:
        this.form.value.coefConstr_Ampliacion_Alteracion,
      coefConstr_Total_Proyecto: this.form.value.coefConstr_Total_Proyecto,
      /* DISTANCIAMIENTOS */
      distanciamientos_Proyectada_Permiso:
        this.form.value.distanciamientos_Proyectada_Permiso,
      distanciamientos_Permitido_Norma:
        this.form.value.distanciamientos_Permitido_Norma,
      distanciamientos_Ampliacion_Alteracion:
        this.form.value.distanciamientos_Ampliacion_Alteracion,
      distanciamientos_Total_Proyecto:
        this.form.value.distanciamientos_Total_Proyecto,
      /* RASANTE */
      rasante_Proyectada_Permiso:
        this.form.value.rasante_Proyectada_Permiso,
      rasante_Permitido_Norma: this.form.value.rasante_Permitido_Norma,
      rasante_Ampliacion_Alteracion:
        this.form.value.rasante_Ampliacion_Alteracion,
      rasante_Total_Proyecto: this.form.value.rasante_Total_Proyecto,
      /* SISTEMA DE AGRUPAMIENTO */
      agrupamiento_Proyectada_Permiso:
        this.form.value.agrupamiento_Proyectada_Permiso,
      agrupamiento_Permitido_Norma:
        this.form.value.agrupamiento_Permitido_Norma,
      agrupamiento_Ampliacion_Alteracion:
        this.form.value.agrupamiento_Ampliacion_Alteracion,
      agrupamiento_Total_Proyecto:
        this.form.value.agrupamiento_Total_Proyecto,
      /* ADOSAMIENTO */
      adosamiento_Proyectada_Permiso:
        this.form.value.adosamiento_Proyectada_Permiso,
      adosamiento_Permitido_Norma:
        this.form.value.adosamiento_Permitido_Norma,
      adosamiento_Ampliacion_Alteracion:
        this.form.value.adosamiento_Ampliacion_Alteracion,
      adosamiento_Total_Proyecto:
        this.form.value.adosamiento_Total_Proyecto,
      /* ANTEJARDÍN */
      antejardin_Proyectada_Permiso:
        this.form.value.antejardin_Proyectada_Permiso,
      antejardin_Permitido_Norma:
        this.form.value.antejardin_Permitido_Norma,
      antejardin_Ampliacion_Alteracion:
        this.form.value.antejardin_Ampliacion_Alteracion,
      antejardin_Total_Proyecto: this.form.value.antejardin_Total_Proyecto,
      /* ALTURA EN METROS Y/O PISOS */
      altura_Proyectada_Permiso: this.form.value.altura_Proyectada_Permiso,
      altura_Permitido_Norma: this.form.value.altura_Permitido_Norma,
      altura_Ampliacion_Alteracion:
        this.form.value.altura_Ampliacion_Alteracion,
      altura_Total_Proyecto: this.form.value.altura_Total_Proyecto,
      /* ESTACIONAMIENTOS AUTOMÓVILES */
      automoviles_Proyectada_Permiso:
        this.form.value.automoviles_Proyectada_Permiso,
      automoviles_Permitido_Norma:
        this.form.value.automoviles_Permitido_Norma,
      automoviles_Ampliacion_Alteracion:
        this.form.value.automoviles_Ampliacion_Alteracion,
      automoviles_Total_Proyecto:
        this.form.value.automoviles_Total_Proyecto,
      /* ESTACIONAMIENTOS BICICLETAS */
      bicicletas_Proyectada_Permiso:
        this.form.value.bicicletas_Proyectada_Permiso,
      bicicletas_Permitido_Norma:
        this.form.value.bicicletas_Permitido_Norma,
      bicicletas_Ampliacion_Alteracion:
        this.form.value.bicicletas_Ampliacion_Alteracion,
      bicicletas_Total_Proyecto: this.form.value.bicicletas_Total_Proyecto,
      /* ESTACIONAMIENTOS OTROS VEHÍCULOS (ESPECIFICAR */
      otrosVehiculos_Especificar:
        this.form.value.otrosVehiculos_Especificar, //especificar
      otrosVehiculos_Proyectada_Permiso:
        this.form.value.otrosVehiculos_Proyectada_Permiso,
      otrosVehiculos_Permitido_Norma:
        this.form.value.otrosVehiculos_Permitido_Norma,
      otrosVehiculos_Ampliacion_Alteracion:
        this.form.value.otrosVehiculos_Ampliacion_Alteracion,
      otrosVehiculos_Total_Proyecto:
        this.form.value.otrosVehiculos_Total_Proyecto,
      /* ESTACIONAMIENTOS PARA PERSONAS CON DISCAPACIDAD */
      personasDiscapacidad_Proyectada_Permiso:
        this.form.value.personasDiscapacidad_Proyectada_Permiso,
      personasDiscapacidad_Permitido_Norma:
        this.form.value.personasDiscapacidad_Permitido_Norma,
      personasDiscapacidad_Ampliacion_Alteracion:
        this.form.value.personasDiscapacidad_Ampliacion_Alteracion,
      personasDiscapacidad_Total_Proyecto:
        this.form.value.personasDiscapacidad_Total_Proyecto,
      /* DESCUENTO ESTACIONAMIENTO PARA AUTOMÓVILES POR
        ESTACIONAMIENTO PARA BICICLETAS  o  (PERMISO(S) ANTERIOR(ES))*/
      descuento_Est: this.form.value.descuento_Est,
      descuento_EstCant: this.form.value.descuento_EstCant,
      /* DESCUENTO ESTACIONAMIENTO PARA AUTOMOVILES POR
        ESTACIONAMIENTO PARA BICICLETAS INCLUIDO PROYECTO */
      descuento_EstIncluido: this.form.value.descuento_EstIncluido,
      descuento_EstIncluidoCant: this.form.value.descuento_EstIncluidoCant,

      //Form 133
      distanciamientos_V1_Otorgado: this.form.value.distanciamientos_V1_Otorgado,
      distanciamientos_V1_Modificado: this.form.value.distanciamientos_V1_Modificado,
      adosamiento_V1_Otorgado: this.form.value.adosamiento_V1_Otorgado,
      adosamiento_V1_Modificado: this.form.value.adosamiento_V1_Modificado,
      antejardin_V1_Otorgado: this.form.value.antejardin_V1_Otorgado,
      antejardin_V1_Modificado: this.form.value.antejardin_V1_Modificado,
      altura_V1_Otorgado: this.form.value.altura_V1_Otorgado,
      altura_V1_Modificado: this.form.value.altura_V1_Modificado,
      esta_Auto_V1_Otorgado: this.form.value.esta_Auto_V1_Otorgado,
      esta_Auto_V1_Modificado: this.form.value.esta_Auto_V1_Modificado,
      esta_Bici_V1_Otorgado: this.form.value.esta_Bici_V1_Otorgado,
      esta_Bici_V1_Modificado: this.form.value.esta_Bici_V1_Modificado,

      distanciamientos_V2_Otorgado: this.form.value.distanciamientos_V2_Otorgado,
      distanciamientos_V2_Modificado: this.form.value.distanciamientos_V2_Modificado,
      adosamiento_V2_Otorgado: this.form.value.adosamiento_V2_Otorgado,
      adosamiento_V2_Modificado: this.form.value.adosamiento_V2_Modificado,
      antejardin_V2_Otorgado: this.form.value.antejardin_V2_Otorgado,
      antejardin_V2_Modificado: this.form.value.antejardin_V2_Modificado,
      altura_V2_Otorgado: this.form.value.altura_V2_Otorgado,
      altura_V2_Modificado: this.form.value.altura_V2_Modificado,
      esta_Auto_V2_Otorgado: this.form.value.esta_Auto_V2_Otorgado,
      esta_Auto_V2_Modificado: this.form.value.esta_Auto_V2_Modificado,
      esta_Bici_V2_Otorgado: this.form.value.esta_Bici_V2_Otorgado,
      esta_Bici_V2_Modificado: this.form.value.esta_Bici_V2_Modificado,

      distanciamientos_V3_Otorgado: this.form.value.distanciamientos_V3_Otorgado,
      distanciamientos_V3_Modificado: this.form.value.distanciamientos_V3_Modificado,
      adosamiento_V3_Otorgado: this.form.value.adosamiento_V3_Otorgado,
      adosamiento_V3_Modificado: this.form.value.adosamiento_V3_Modificado,
      antejardin_V3_Otorgado: this.form.value.antejardin_V3_Otorgado,
      antejardin_V3_Modificado: this.form.value.antejardin_V3_Modificado,
      altura_V3_Otorgado: this.form.value.altura_V3_Otorgado,
      altura_V3_Modificado: this.form.value.altura_V3_Modificado,
      esta_Auto_V3_Otorgado: this.form.value.esta_Auto_V3_Otorgado,
      esta_Auto_V3_Modificado: this.form.value.esta_Auto_V3_Modificado,
      esta_Bici_V3_Otorgado: this.form.value.esta_Bici_V3_Otorgado,
      esta_Bici_V3_Modificado: this.form.value.esta_Bici_V3_Modificado,
      esta_Bici_Permitido_Otorgado: this.form.value.esta_Bici_Permitido_Otorgado,
      esta_Bici_Permitido_Modificado: this.form.value.esta_Bici_Permitido_Modificado,
    });
    localStorage.setItem("normas_urbanisticas", JSON.stringify(this.rows));
  }

  delete_normas(id) {
    for (let x = 0; x < this.rows.length; x++) {
      if (id == x) {
        this.rows.splice(x, 1);
        localStorage.setItem("normas_urbanisticas", JSON.stringify(this.rows));
      }
    }
  }
}